import { useTranslation } from '@mint-lib/i18n';
import { Chat, ChevronDown, EventSchedule } from '@mint-lib/icons';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@mint-lib/tw-components';

export type MessageMode = 'chat' | 'scheduled';

type Props = {
  value: MessageMode;
  onChange: (mode: MessageMode) => void;
  isDisabled: boolean;
};

const MessageModeDropdown = ({ value, onChange, isDisabled }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild data-interactive disabled={isDisabled}>
        <Button variant="text" className="gap-1">
          {value === 'chat' ? (
            <Chat className="size-4" />
          ) : (
            <EventSchedule className="size-4" />
          )}
          {value === 'chat' ? t('Chat') : t('Scheduled')}
          <ChevronDown className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-popover">
        <DropdownMenuItem
          selected={value === 'chat'}
          onSelect={() => onChange('chat')}
        >
          {t('Chat')}
        </DropdownMenuItem>
        <DropdownMenuItem
          selected={value === 'scheduled'}
          onSelect={() => onChange('scheduled')}
        >
          {t('Scheduled')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { MessageModeDropdown };
